
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { appFragments } from 'src/admin-app/rpfsa.route.paths';

@Injectable({
	providedIn: 'root',
})
export class RoleGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot): boolean {
		const roles = next.data['roles'] as Array<string>;
		const userRoles = this.authService.userRoles;
		if (!userRoles) {
			throw new Error('User profile missing roles.');
		}

		const authorized: boolean = roles.some((role) =>
			userRoles.includes(role)
		);

		if (!authorized) {
			this.router.navigate(appFragments.notAuthorized);
			return false;
		}

		return true;
	}
}
